/* global $ */

import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
// import CommonPage from './CommonPage';
// import Accordion from './Accordion';
barba.use(barbaPrefetch);

// import Swiper, { Pagination } from "swiper";
// import PageHome from './PageHome';

class Router {
  constructor(mainApp) {
    this.mainApp = mainApp;
    this.currentNamespace = '';
    this.pageApp = undefined;

    barba.init({
      timeout: 6000,
      debug: false,
      transitions: [
        {
          name: 'default',
          beforeOnce: () => {},
          once: (data) => {
            this.currentNamespace = data['next']['namespace'];
          },
          afterOnce: (data) => {
            this.checkPageApp(data);
            // this.mainApp.initPageApp(this.currentNamespace);
          },
          before: async () => {
            clearTimeout(this.fadeinTimer);
            this.mainApp.clearPageApp();
            /*
            if(this.pageApp != undefined) {
              this.pageApp.destroy();
              this.pageApp = undefined;
            }
            */

            let waitDuration = 0;
            await new Promise((resolve) => {
              return setTimeout(resolve, waitDuration);
            });
          },
          leave: () => {
            // console.log('leave');
          },
          enter: (data) => {
            // console.log('enter');
            window.scrollTo(0, 0);
            this.checkPageApp(data);

            this.currentNamespace = data['next']['namespace'];
          },
        },
      ],
    });

    /*
    $('body').on('click', '.js-router-force' , (e) => {
      e.preventDefault();
      barba.force('//' + window.host_uri + $(e.currentTarget).attr('href'));
      return false;
    });
    */

    window.appRouter = barba;
  }

  go(target) {
    barba.go(target);
  }

  checkPageApp(data) {
    this.currentNamespace = data.next.namespace;
    $('body').attr('data-namespace', this.currentNamespace);

    setTimeout(() => {
      this.mainApp.checkPageApp(this.currentNamespace);
    }, 30);
    /*
    setTimeout(() => {
      if (this.currentNamespace == 'home') {
        this.pageApp = new PageHome(this.mainApp);
      } else {
        this.pageApp = new CommonPage(this.mainApp);
      }

      this.mainApp.checkPageApp();
      this.mainApp.header.setCurrentPosition(this.currentNamespace);

      setTimeout(() => {
        this.pageApp.onWindowResize();
      }, 200);
    }, 30);
    */
  }
}

export default Router;
